class JmfProductGallery {
  constructor(root) {
    this.root = root;
    this.mainButton = root.querySelector('.jmf-gallery-main');
    this.mainImage = root.querySelector('.jmf-gallery-main-image');
    this.items = Array.from(root.querySelectorAll('[data-jmf-gallery-thumb]'));
    this.lightbox = root.querySelector('[data-jmf-gallery-lightbox]');
    this.lightboxImage = root.querySelector('[data-jmf-gallery-lightbox-image]');
    this.status = root.querySelector('[data-jmf-gallery-status]');
    this.currentIndex = 0;
    this.lastFocused = null;

    if (!this.mainButton || !this.mainImage || !this.lightbox || !this.items.length) return;
    this.bindEvents();
  }

  bindEvents() {
    this.items.forEach((item, index) => {
      const button = item.querySelector('.jmf-gallery-thumb');
      if (!button) return;
      button.addEventListener('click', () => {
        this.select(index);
        if (window.matchMedia('(max-width: 1023px)').matches) this.open();
      });
    });

    this.mainButton.addEventListener('click', () => {
      this.open();
    });

    this.root.querySelectorAll('[data-jmf-gallery-close]').forEach((button) => {
      button.addEventListener('click', () => this.close());
    });

    this.root.querySelector('[data-jmf-gallery-previous]')?.addEventListener('click', () => this.step(-1));
    this.root.querySelector('[data-jmf-gallery-next]')?.addEventListener('click', () => this.step(1));

    this.lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
      if (event.key === 'ArrowLeft') this.step(-1);
      if (event.key === 'ArrowRight') this.step(1);
    });
  }

  select(index) {
    const item = this.items[index];
    const thumbImage = item?.querySelector('img');
    if (!item || !thumbImage) return;

    this.currentIndex = index;
    this.mainImage.src = item.dataset.fullImage || thumbImage.currentSrc || thumbImage.src;
    this.mainImage.removeAttribute('srcset');
    this.mainImage.alt = thumbImage.alt || '';
    this.mainButton.setAttribute('aria-label', `Zoom ${this.mainImage.alt || 'product image'}`);

    this.items.forEach((galleryItem, itemIndex) => {
      const active = itemIndex === index;
      galleryItem.classList.toggle('is-active', active);
      const button = galleryItem.querySelector('.jmf-gallery-thumb');
      if (button) {
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      }
    });
  }

  updateLightbox() {
    const item = this.items[this.currentIndex];
    const image = item?.querySelector('img');
    if (!item || !image) return;
    this.lightboxImage.src = item.dataset.fullImage || image.currentSrc || image.src;
    this.lightboxImage.alt = image.alt || '';
    this.status.textContent = `${this.currentIndex + 1} of ${this.items.length}`;
  }

  open() {
    this.updateLightbox();
    this.lastFocused = document.activeElement;
    this.lightbox.hidden = false;
    this.lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('jmf-gallery-is-open');
    this.lightbox.querySelector('[data-jmf-gallery-close]:not([tabindex="-1"])')?.focus();
  }

  close() {
    if (this.lightbox.hidden) return;
    this.lightbox.hidden = true;
    this.lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('jmf-gallery-is-open');
    if (window.matchMedia('(max-width: 1023px)').matches) this.select(0);
    this.lastFocused?.focus();
  }

  step(direction) {
    this.currentIndex = (this.currentIndex + direction + this.items.length) % this.items.length;
    this.select(this.currentIndex);
    this.updateLightbox();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-jmf-product-gallery]').forEach((gallery) => new JmfProductGallery(gallery));
});
